var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "component-fade", mode: "out-in" } },
    [
      _vm.video !== null
        ? _c(
            "div",
            {
              staticClass: "card noselect",
              class: [
                _vm.hovered ? "shadow-lg" : "shadow-sm",
                _vm.pageLinkEnabled ? "cursor-pointer" : "",
                _vm.hoverEffectEnabled ? "card-hover" : ""
              ],
              on: {
                mouseenter: function($event) {
                  _vm.hovered = true
                },
                mouseleave: function($event) {
                  _vm.hovered = false
                },
                click: _vm.cardClicked
              }
            },
            [
              _vm.thumbnailEnabled && _vm.kissVideoExisting
                ? _c("img", {
                    staticClass: "card-img-top rounded",
                    attrs: {
                      src: _vm.video.kiss_video.thumbnail_url,
                      alt: _vm.video.title[_vm.$i18n.locale]
                    },
                    on: {
                      load: function($event) {
                        _vm.imageLoaded = true
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.thumbnailEnabled && !_vm.kissVideoExisting
                ? _c("img", {
                    staticClass: "card-img-top rounded",
                    attrs: {
                      src:
                        "https://placehold.it/400x200?text=Video+not+available"
                    },
                    on: {
                      load: function($event) {
                        _vm.imageLoaded = true
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.imageLoaded && _vm.thumbnailEnabled
                ? _c(
                    "div",
                    {
                      staticClass: "text-center bg-light",
                      staticStyle: {
                        "padding-top": "80px",
                        "padding-bottom": "80px"
                      }
                    },
                    [
                      _c("i", {
                        staticClass:
                          "mdi mdi-spin mdi-autorenew mdi-36px text-primary"
                      })
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                [
                  _vm.startedWatching && _vm.showProgress
                    ? _c(
                        "div",
                        {
                          staticClass: "progress radius-none",
                          staticStyle: { "margin-bottom": "-10px" }
                        },
                        [
                          _c("div", {
                            staticClass: "progress-bar bg-primary radius-none",
                            style: "width: " + _vm.percentageWatched + "%",
                            attrs: {
                              role: "progressbar",
                              "aria-valuenow": _vm.percentageWatched,
                              "aria-valuemin": "0",
                              "aria-valuemax": "100"
                            }
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-body p-4" },
                    [
                      _c("h5", { staticClass: "card-text" }, [
                        _vm._v(_vm._s(_vm.videoTitle))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mb-5" }, [
                        _c(
                          "span",
                          {
                            staticClass: "text-muted",
                            attrs: {
                              title: _vm
                                .$date(_vm.video.published_at)
                                .format("DD.MM.YYYY HH:mm")
                            }
                          },
                          [
                            _c("i", { staticClass: "mdi mdi-calendar" }),
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$date(_vm.video.published_at).fromNow()
                                ) +
                                "\n                    "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("gym-video-level-badge", {
                        attrs: {
                          level: _vm.video.level,
                          label: _vm.video.localized_level
                        }
                      }),
                      _vm._v(" "),
                      _c("gym-video-intensity-badge", {
                        attrs: { intensity: _vm.video.intensity }
                      }),
                      _vm._v(" "),
                      _c("gym-video-duration-badge", {
                        attrs: { duration: _vm.video.duration }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._t("footer", [
                    _vm.showLike || _vm.showCompleted
                      ? _c("div", { staticClass: "card-footer pl-4 pr-4" }, [
                          _c("div", { staticClass: "row mt-2" }, [
                            _vm.showLike
                              ? _c("div", { staticClass: "col" }, [
                                  _c("i", {
                                    staticClass: "mdi mdi-24px",
                                    class: [
                                      _vm.isVideoFavored
                                        ? "text-primary mdi-heart"
                                        : "mdi-heart-outline text-muted"
                                    ]
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showCompleted
                              ? _c("div", { staticClass: "col text-right" }, [
                                  _vm.watchedEntirely
                                    ? _c("i", {
                                        staticClass:
                                          "mdi mdi-24px text-primary mdi-check-decagram"
                                      })
                                    : _vm._e()
                                ])
                              : _vm._e()
                          ])
                        ])
                      : _vm._e()
                  ])
                ],
                2
              )
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }